import angular from 'angular';


const ngPlaceholder = angular.module('ttb.directives.ngPlaceholder', [])
  .directive('ngPlaceholder', () => {
    return {
      restrict: 'A',
      scope: {
        placeholder: '=ngPlaceholder'
      },
      link: function (scope, elem, attr) {
        scope.$watch('placeholder', function () {
          elem[0].placeholder = scope.placeholder || '';
        });
      }
    }
  })
  .name;

  export default ngPlaceholder;


// WEBPACK FOOTER //
// ../directives/ng-placeholder.js